import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token if we have one stashed (fallback when cookies are blocked cross-site)
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? window.localStorage.getItem("td_token") : null;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const SERVICES = [
  {
    slug: "household-junk",
    title: "Household Junk Removal",
    short: "Furniture, boxes, garage & attic cleanouts.",
    pricing: { high: 129, mid: 99, low: 89 },
    icon: "Sofa",
    keywords: ["junk removal", "household junk hauling", "garage cleanout"],
  },
  {
    slug: "yard-debris",
    title: "Yard Debris Hauling",
    short: "Branches, leaves, brush & land clearing debris.",
    pricing: { high: 179, mid: 149, low: 129 },
    icon: "Trees",
    keywords: ["yard waste removal", "brush hauling", "land clearing debris"],
  },
  {
    slug: "construction-debris",
    title: "Construction Debris",
    short: "Drywall, wood, tile, roofing & remodel waste.",
    pricing: { high: 299, mid: 249, low: 199 },
    icon: "HardHat",
    keywords: ["construction debris removal", "remodel cleanup"],
  },
  {
    slug: "bulk-pickup",
    title: "Bulk Item Pickup",
    short: "Mattresses, couches, hot tubs, sheds & more.",
    pricing: { high: 109, mid: 89, low: 79 },
    icon: "PackageOpen",
    keywords: ["bulk trash pickup", "mattress removal", "couch hauling"],
  },
  {
    slug: "appliance-removal",
    title: "Appliance Removal",
    short: "Refrigerators, washers, dryers, stoves, water heaters.",
    pricing: { high: 109, mid: 99, low: 89 },
    icon: "Refrigerator",
    keywords: ["appliance removal", "refrigerator disposal", "water heater haul away"],
  },
  {
    slug: "eviction-cleanout",
    title: "Eviction Cleanouts",
    short: "Full property cleanouts for landlords & PMs — fast turnaround.",
    pricing: { high: 849, mid: 649, low: 499 },
    icon: "DoorOpen",
    keywords: ["eviction cleanout", "rental property cleanout", "landlord hauling"],
  },
  {
    slug: "storm-cleanup",
    title: "Storm Cleanup",
    short: "Hurricane & storm debris removal — flexible pricing.",
    pricing: { high: 249, mid: 225, low: 175 },
    icon: "CloudLightning",
    keywords: ["storm debris removal", "hurricane cleanup"],
  },
  {
    slug: "dumpster-rental",
    title: "Dumpster Rental Referrals",
    short: "10, 20 & 30-yard roll-offs matched with vetted local partners.",
    pricing: { high: 499, mid: 399, low: 349 },
    icon: "Container",
    keywords: ["dumpster rental", "roll off dumpster"],
  },
];

export const REGIONS = [
  { key: "high", label: "High-cost market", note: "CA, NY, expensive metros" },
  { key: "mid", label: "Mid-cost market", note: "FL, avg. suburbs" },
  { key: "low", label: "Low-cost market", note: "TX, rural / lower-cost" },
];

export const PRICING_DISCLAIMER =
  "Prices start at the amounts listed below. Final pricing depends on location, load size, material type, stairs, distance, urgency, and disposal requirements. Send photos for an exact quote.";

export const SERVICE_AREAS = [
  { slug: "wesley-chapel", name: "Wesley Chapel", county: "Pasco County", featured: true },
  { slug: "zephyrhills", name: "Zephyrhills", county: "Pasco County" },
  { slug: "dade-city", name: "Dade City", county: "Pasco County" },
  { slug: "san-antonio", name: "San Antonio", county: "Pasco County" },
  { slug: "land-o-lakes", name: "Land O' Lakes", county: "Pasco County" },
  { slug: "lutz", name: "Lutz", county: "Hillsborough County" },
  { slug: "odessa", name: "Odessa", county: "Pasco County" },
  { slug: "brooksville", name: "Brooksville", county: "Hernando County" },
  { slug: "spring-hill", name: "Spring Hill", county: "Hernando County" },
];
